import { memo } from 'react';
import { Radar } from 'lucide-react';
import { BaseNode, type NodeData } from './BaseNode';

function MarketSignalNodeComponent({ data, selected }: { data: NodeData; selected?: boolean }) {
  return <BaseNode data={data} selected={selected} icon={Radar} nodeType="market_signal" />;
}

export const MarketSignalNode = memo(MarketSignalNodeComponent);
